// 축하 정보 관련 API
import * as BaseApi from "api/Base.api";
const BASE_URL = "/student/v2/congratulation";

//* 축하 정보 조회
export const doLike = async (congratulationItemId: number) => {
    console.log('api/student/v2/congratulation.api:doLike', congratulationItemId);
    const result = await BaseApi.patch(BASE_URL + `/like/${congratulationItemId}`, null);
    return result.data;
};